import React from 'react';
import './index.css';
import 'animate.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getCache, setCache } from './hook/useCache';
import { CacheEnum } from './enum/cache';
import { ColorModeType } from './config/type';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const cachedColorMode =
  getCache({
    key: CacheEnum.colorMode,
    storage: localStorage,
  }) || ColorModeType.light;
applyColorMode(cachedColorMode);

function applyColorMode(colorMode: ColorModeType) {
  const body = document.body;
  if (colorMode === ColorModeType.dark) {
    body.setAttribute('theme-mode', 'dark');
    document.documentElement.classList.add('dark');
  } else {
    body.removeAttribute('theme-mode');
    document.documentElement.classList.remove('dark');
  }
  setCache({
    key: CacheEnum.colorMode,
    value: colorMode,
    storage: localStorage,
  });
}

// 导入存储调试工具（仅在开发环境）
if (process.env.NODE_ENV === 'development') {
  import('./utils/storageDebug');
}
